import { httpClient } from "@/services";

export default {
	state: {
		motivationProgramData: null,
		motivationProgramList: null,
		motivationProgramFilter: null,
		motivationProgramInfo: null,
	},
	mutations: {
		updateMotivationProgram(state, payload) {
			state.motivationProgramData = payload;
		},
		updateMotivationProgramList(state, { workOrder, filter, ...obj }) {
			state.motivationProgramList = workOrder;
			state.motivationProgramFilter = filter;
			state.motivationProgramInfo = obj;
		}
	},
	actions: {
		async onMotivationProgram({ commit }) {
			try {
				const { data } = await httpClient.get('/motivation');
				if (data && !data.error) {
					commit('updateMotivationProgram', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onMotivationProgramFilter({ commit }, { currentDate, ...filters }) {
			try {
				const { data } = await httpClient.post(`/motivation/show/${ currentDate }`, filters);
				if (data && !data.status) {
					commit('updateMotivationProgramList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onMotivationProgramEdit({ commit }, values) {
			try {
				const { data } = await httpClient.post('/motivation/list', values);
				if (data && !data.error) {
					commit('updateMotivationProgram', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onMotivationProgramInfo({ commit }, { date, values }) {
			try {
				const { data } = await httpClient.post(`/motivation/show/${ date }`, values);
				if (data && !data.status) {
					commit('updateMotivationProgramList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {
		motivationProgramData: s => s.motivationProgramData,
		motivationProgramInfo: s => s.motivationProgramInfo,
		motivationProgramFilter: s => s.motivationProgramFilter,
		motivationProgramList: s => s.motivationProgramList
	}
};
